export const betSectionBoxesText = {
  split: '1/2',
  multiply: 'x2',
  min: 'MIN',
  max: 'MAX',
  allIn: 'ALL_IN',
};
